import { normalizeOptions } from '@formkit/inputs'
import { ElRadio, ElRadioGroup } from 'element-plus'
import { computed, defineComponent, h, onMounted } from 'vue'

export default defineComponent({
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const options = normalizeOptions(props.context.attrs?.options ?? []).map((option) => {
      const labelChildren = [h('span', { innerHTML: option.label })]
      if (option.isTopChoice) {
        labelChildren.push(
          h(
            'span',
            {
              class: 'ml-4 inline-flex items-top gap-1 text-xs font-semibold text-yellow-600 bg-yellow-100 px-1.5 py-0.5 rounded',
              style: 'vertical-align: middle;',
            },
            [
              h(
                'svg',
                {
                  xmlns: 'http://www.w3.org/2000/svg',
                  fill: 'currentColor',
                  viewBox: '0 0 24 24',
                  width: 14,
                  height: 14,
                },
                [
                  h('path', {
                    d: 'M12 2l2.39 7.26H22l-6.18 4.49L17.82 22 12 17.77 6.18 22l1.36-8.25L2 9.26h7.61z',
                  }),
                ],
              ),
              h('span', 'Top Choice'),
            ],
          ),
        )
      }

      return h(
        ElRadio,
        {
          label: option.__original ?? option.value,
          class: props.context.attrs?.radioClasses,
          border: option.border !== undefined ? option.border : true,
        },
        () => h('div', { class: 'flex items-center' }, labelChildren),
      )
    })

    const classes = computed(() => props.context.attrs?.class + (props.context.error ? ' error' : ''))
    const defaultValue = computed(() => props.context?.attrs?.default || undefined)

    const value = computed({
      get: () => props.context.value,
      set: (val) => {
        props.context.node.input(val)
        if (props.context.attrs?.onChangeCallback) {
          props.context.attrs.onChangeCallback(val, props.context.node)
        }
      },
    })

    onMounted(() => {
      if (value.value === undefined && defaultValue.value !== undefined) {
        props.context.node.input(defaultValue.value)
      }
    })

    return () =>
      h(
        ElRadioGroup,
        {
          modelValue: value.value,
          'onUpdate:modelValue': (val) => (value.value = val),
          class: classes.value,
          disabled: props.context.disabled,
        },
        () => options,
      )
  },
})
